<template>
  <div class="login-page">
    <div class="login-left">
      <div class="login-brand">
        <span class="logo">◇</span>
        <h1 class="headline">个人助手</h1>
        <p class="tagline">单词 · 笔记 · 日记，一处归心</p>
      </div>
      <div class="login-visual">
        <div class="grid-pattern"></div>
      </div>
    </div>
    <div class="login-right">
      <div class="login-form-wrap">
        <h2 class="form-title">登录</h2>
        <form @submit.prevent="login" class="login-form">
          <div class="form-group">
            <label for="userName">用户名</label>
            <input
              type="text"
              id="userName"
              v-model="loginForm.userName"
              placeholder="请输入用户名"
              required
              autofocus
            >
          </div>
          <div class="form-group">
            <label for="passWord">密码</label>
            <input
              type="password"
              id="passWord"
              v-model="loginForm.passWord"
              placeholder="请输入密码"
              required
            >
          </div>
          <button type="submit" class="btn-login" :disabled="loading">
            <span v-if="loading" class="loading-spinner"></span>
            {{ loading ? '登录中...' : '登录' }}
          </button>
          <div v-if="error" class="error-message">{{ error }}</div>
        </form>
        <p class="login-footer">© 个人助手</p>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/user'

export default {
  name: 'LoginView',
  data() {
    return {
      loginForm: { userName: '', passWord: '' },
      loading: false,
      error: ''
    }
  },
  methods: {
    async login() {
      this.loading = true
      this.error = ''
      try {
        const response = await login(this.loginForm)
        if (response.data && response.data.success && response.data.data) {
          const { token, refreshToken, userName } = response.data.data
          localStorage.setItem('token', token)
          if (refreshToken) localStorage.setItem('refreshToken', refreshToken)
          localStorage.setItem('userName', userName)
          this.$router.push('/home')
        } else {
          this.error = response.data.errMsg || '登录失败，请检查用户名和密码'
        }
      } catch (err) {
        this.error = '登录失败，请检查网络连接或服务器状态'
        console.error('登录错误:', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* 分屏登录 - Stripe / Vercel 风格：左品牌右表单 */
.login-page {
  display: flex;
  min-height: 100vh;
}

.login-left {
  flex: 1;
  background: var(--side-bg);
  color: var(--side-text);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 56px 56px;
  min-height: 100vh;
}

.login-brand {
  margin-top: 0;
}

.logo {
  width: 48px;
  height: 48px;
  background: var(--accent);
  color: #fff;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 800;
  font-family: var(--font-display);
  margin-bottom: 32px;
}

.headline {
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
  margin-bottom: 12px;
}

.tagline {
  font-size: 1.1rem;
  color: var(--side-text-dim);
  font-weight: 500;
}

.login-visual {
  position: relative;
  height: 200px;
}

.grid-pattern {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 32px 32px;
}

.login-right {
  width: 480px;
  min-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: var(--surface-card);
  border-left: 1px solid var(--border);
}

.login-form-wrap {
  width: 100%;
  max-width: 320px;
}

.form-title {
  font-family: var(--font-display);
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--ink);
  margin-bottom: 32px;
  letter-spacing: -0.02em;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ink-secondary);
}

.form-group input {
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 1rem;
  background: var(--surface);
  color: var(--ink);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

.btn-login {
  margin-top: 8px;
  padding: 14px 24px;
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: var(--radius);
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.2s;
}

.btn-login:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.error-message {
  background: rgba(239, 68, 68, 0.08);
  color: var(--danger);
  padding: 12px 16px;
  border-radius: var(--radius);
  font-size: 0.9rem;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.login-footer {
  margin-top: 40px;
  font-size: 0.85rem;
  color: var(--ink-muted);
}

@media (max-width: 900px) {
  .login-page { flex-direction: column; }
  .login-left {
    min-height: auto;
    padding: 40px 24px 32px;
  }
  .login-visual { display: none; }
  .login-right {
    width: 100%;
    min-width: 0;
    padding: 32px 24px;
  }
}
</style>
